<template>
  <p>
    {{ i18n(translations.activeShippingProvidersLabel) }}<br />
    <span class="flex flex-wrap gap-6">
      <RevTag
        :label="
          i18n(translations.activeShippingProvidersTag, {
            weekday: getWeekday('SATURDAY'),
            activeShippingProviders: saturdayActiveShippingProviders,
          })
        "
        variant="secondary"
      />
      <RevTag
        :label="
          i18n(translations.activeShippingProvidersTag, {
            weekday: getWeekday('SUNDAY'),
            activeShippingProviders: sundayActiveShippingProviders,
          })
        "
        variant="secondary"
      />
    </span>
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'

import { useGetWeekday } from '../../../../composables/useGetWeekday'

import translations from './ActiveShippingProviders.translations'
import type { ActiveShippingProvidersProps } from './ActiveShippingProviders.types'

const i18n = useI18n()

const { weekendDeliveryConfigurations } =
  defineProps<ActiveShippingProvidersProps>()

const getWeekday = useGetWeekday()

const saturdayActiveShippingProviders = computed(() => {
  return (
    weekendDeliveryConfigurations.filter(
      ({ day, workingDay }) => day === 'SATURDAY' && workingDay,
    ).length || 0
  )
})

const sundayActiveShippingProviders = computed(() => {
  return (
    weekendDeliveryConfigurations.filter(
      ({ day, workingDay }) => day === 'SUNDAY' && workingDay,
    ).length || 0
  )
})
</script>
